import { createSlice } from '@reduxjs/toolkit';

const initialState = { session: "", identity:false };

export const yoti = createSlice({
    name: 'yoti',
    initialState,
    reducers: {
        setSession: (state, action) => {
            state.session = action.payload;
        },
        setIdentity:(state,action)=>{
            state.identity = action.payload;
        }
    },
});

export const { setSession, setIdentity } = yoti.actions;

export default yoti.reducer;
